import { View, StyleSheet, Text } from '@react-pdf/renderer';
import { deutschNumberFormatter } from '../helper/utils';
import { IOfferPosition } from '../interface/IOfferPosition';

type Props = {
  data?: Partial<IOfferPosition>[] | null;
  discount?: string;
};

const OfferPdfTable = ({ data, discount }: Props) => {
  const styles = StyleSheet.create({
    table: {
      display: 'flex',
      width: '100%',
      // borderStyle: 'solid',
      // borderWidth: 1,
      // borderRightWidth: 0,
      // borderBottomWidth: 0,
    },
    tableRow: {
      flexDirection: 'row',
      borderBottomWidth: 1,
      borderBottomColor: '#d3d3d3',
      borderBottomStyle: 'solid',
    },
    tableHeader: {
      backgroundColor: '#f0f0f0',
      fontWeight: 'bold',
    },
    tableCellPosition: {
      padding: 5,
      // borderRightWidth: 1,
      // borderRightColor: '#d3d3d3',
      // borderRightStyle: 'solid',
      width: '5%',
    },
    tableCell: {
      padding: 5,
      // borderRightWidth: 1,
      // borderRightColor: '#d3d3d3',
      // borderRightStyle: 'solid',
    },
    tableCellSubject: {
      width: '63%',
    },
    tableCellListPrice: {
      textAlign: 'right',
      width: '11%',
    },
    tableCellDiscount: {
      width: '9.5%',
      textAlign: 'right',
    },

    tableCellAmount: {
      padding: 5,
      textAlign: 'right',
      width: '11%',
    },
    descriptionText: {
      color: '#494949',
      fontSize: 9,
    },
    tableCol: {
      padding: 2,
      borderStyle: 'solid',
      borderWidth: 0.5,
      borderColor: '#616161',
      // borderLeftWidth: 0,
      // borderTopWidth: 0,
    },
    // tableCell: {
    //   marginTop: 2,
    //   fontSize: 10,
    // },
  });
  return (
    <View style={styles.table}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={styles.tableCellPosition}>Pos</Text>
        <Text style={[styles.tableCell, styles.tableCellSubject]}>Subject</Text>
        <Text style={[styles.tableCell, styles.tableCellListPrice]}>List Price</Text>
        <Text style={[styles.tableCell, styles.tableCellDiscount]}>Discount</Text>
        <Text style={styles.tableCellAmount}>Amount</Text>
      </View>
      {data?.map((item, index) => (
        <View key={index} style={styles.tableRow} wrap={false}>
          <Text style={styles.tableCellPosition}>{item.position}</Text>
          <View style={[styles.tableCell, styles.tableCellSubject]}>
            <Text>{item.subject}</Text>
            <Text style={styles.descriptionText}>{item.description}</Text>
          </View>
          <Text style={[styles.tableCell, styles.tableCellListPrice]}> {deutschNumberFormatter(item.listPrice)} €</Text>
          <Text style={[styles.tableCell, styles.tableCellDiscount]}>{discount}</Text>
          <Text style={styles.tableCellAmount}>{deutschNumberFormatter(item.projectPrice)} €</Text>
        </View>
      ))}
    </View>
  );
};

export default OfferPdfTable;
